var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 48,
    viewBox: "0 0 295 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2162_40698)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_40698)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 48,
    rx: 8,
    fill: "#212129"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2162_40698)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.998,
    y: 10,
    width: 198.891,
    height: 27.72,
    rx: 5.544,
    fill: "#212129"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.998,
    y: 10,
    width: 198.891,
    height: 27.72,
    rx: 5.544,
    stroke: "#414152",
    strokeWidth: 0.693
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.7715,
    y: 12.7734,
    width: 93.9015,
    height: 22.176,
    rx: 4.158,
    fill: "#0012D4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddn_2162_40698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6025 17.0225C72.9694 17.0509 73.3281 17.108 73.6768 17.1914L73.6123 17.4639C73.9536 17.5456 74.2849 17.6531 74.6035 17.7852L74.7109 17.5264C75.0481 17.6662 75.3719 17.8315 75.6797 18.0205L75.5332 18.2598C75.8307 18.4425 76.1128 18.6482 76.377 18.874L76.5576 18.6611C76.8339 18.8972 77.091 19.1545 77.3271 19.4307L77.1152 19.6123C77.341 19.8764 77.5469 20.1586 77.7295 20.4561L77.9668 20.3086C78.156 20.6165 78.322 20.94 78.4619 21.2773L78.2031 21.3848C78.3354 21.7037 78.4436 22.0353 78.5254 22.377L78.7959 22.3115C78.8794 22.6602 78.9363 23.0188 78.9648 23.3857L78.6875 23.4072C78.7009 23.5795 78.708 23.7539 78.708 23.9297C78.708 24.1055 78.7009 24.2799 78.6875 24.4521L78.9648 24.4736C78.9364 24.8406 78.8793 25.1991 78.7959 25.5479L78.5254 25.4834C78.4437 25.8248 78.3353 26.1559 78.2031 26.4746L78.4619 26.582C78.322 26.9194 78.1559 27.2428 77.9668 27.5508L77.7295 27.4043C77.5468 27.7018 77.3411 27.9839 77.1152 28.248L77.3271 28.4287C77.091 28.7049 76.8339 28.9621 76.5576 29.1982L76.377 28.9863C76.1128 29.2121 75.8307 29.4179 75.5332 29.6006L75.6797 29.8379C75.3717 30.027 75.0483 30.1931 74.7109 30.333L74.6035 30.0742C74.2848 30.2064 73.9538 30.3148 73.6123 30.3965L73.6768 30.667C73.328 30.7504 72.9695 30.8074 72.6025 30.8359L72.5811 30.5586C72.4088 30.572 72.2344 30.5791 72.0586 30.5791C71.8828 30.5791 71.7084 30.572 71.5361 30.5586L71.5146 30.8359C71.1477 30.8074 70.7891 30.7505 70.4404 30.667L70.5059 30.3965C70.1642 30.3147 69.8326 30.2065 69.5137 30.0742L69.4062 30.333C69.0689 30.1931 68.7454 30.0271 68.4375 29.8379L68.585 29.6006C68.2876 29.418 68.0053 29.2121 67.7412 28.9863L67.5596 29.1982C67.2834 28.9621 67.0261 28.7049 66.79 28.4287L67.0029 28.248C66.7771 27.9838 66.5714 27.7018 66.3887 27.4043L66.1494 27.5508C65.9604 27.243 65.7951 26.9192 65.6553 26.582L65.9141 26.4746C65.782 26.156 65.6745 25.8247 65.5928 25.4834L65.3203 25.5479C65.2369 25.1992 65.1798 24.8405 65.1514 24.4736L65.4307 24.4521C65.424 24.366 65.4184 24.2794 65.415 24.1924L65.4102 23.9297C65.4102 23.7539 65.4173 23.5795 65.4307 23.4072L65.1514 23.3857C65.1799 23.0188 65.2369 22.6602 65.3203 22.3115L65.5928 22.377C65.6745 22.0353 65.7818 21.7036 65.9141 21.3848L65.6553 21.2773C65.7951 20.9402 65.9604 20.6164 66.1494 20.3086L66.3887 20.4561C66.5713 20.1586 66.7771 19.8765 67.0029 19.6123L66.7891 19.4297C67.0251 19.1535 67.2825 18.8962 67.5586 18.6602L67.7412 18.874C68.0054 18.6482 68.2875 18.4424 68.585 18.2598L68.4375 18.0205C68.7453 17.8315 69.0691 17.6662 69.4062 17.5264L69.5137 17.7852C69.8325 17.6529 70.1642 17.5456 70.5059 17.4639L70.4404 17.1914C70.7891 17.108 71.1477 17.051 71.5146 17.0225L71.5361 17.3018C71.7084 17.2884 71.8828 17.2813 72.0586 17.2812C72.2344 17.2812 72.4088 17.2884 72.5811 17.3018L72.6025 17.0225Z",
    stroke: "#005754",
    strokeWidth: 0.562272,
    strokeDasharray: "1.12 1.12",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_iin_2162_40698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.0581,
    cy: 23.9291,
    r: 6.36773,
    transform: "rotate(180 72.0581 23.9291)",
    fill: "#005754"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_in_2162_40698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5053 24.9799H68.8242V23.1086H72.1805V24.9799H75.294V22.875",
    stroke: "#00CEC8",
    strokeWidth: 0.465463
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.9848 26.9297V20.0413H85.0326V22.9907H88.2148V20.0413H89.2627V26.9297H88.2148V23.9415H85.0326V26.9297H83.9848ZM92.8529 27.0461C91.3491 27.0461 90.408 25.9789 90.408 24.349C90.408 22.719 91.3491 21.6518 92.8238 21.6518C94.2306 21.6518 95.1814 22.6511 95.1814 24.3878V24.6497H91.4752C91.5237 25.6587 92.038 26.1632 92.8626 26.1632C93.4641 26.1632 93.8716 25.8625 94.0366 25.3774L95.1038 25.4453C94.8321 26.4058 93.9881 27.0461 92.8529 27.0461ZM91.4752 23.8736H94.0948C94.0269 22.9616 93.5224 22.525 92.8238 22.525C92.0865 22.525 91.5917 23.0004 91.4752 23.8736ZM97.7733 27.0461C96.6964 27.0461 96.0075 26.5319 96.0075 25.6393C96.0075 24.7564 96.5217 24.281 97.6569 24.0579L99.4323 23.7183C99.4323 22.9228 99.0539 22.525 98.3166 22.525C97.6569 22.525 97.2882 22.8257 97.1523 23.3885L96.0948 23.3205C96.2889 22.2921 97.0941 21.6518 98.3166 21.6518C99.7137 21.6518 100.461 22.4377 100.461 23.7765V25.7849C100.461 26.0371 100.538 26.1147 100.732 26.1147H100.917V26.9297C100.849 26.9491 100.694 26.9588 100.538 26.9588C99.9465 26.9588 99.5973 26.7356 99.5196 26.1341C99.2577 26.6774 98.5785 27.0461 97.7733 27.0461ZM97.9382 26.2311C98.8696 26.2311 99.4323 25.649 99.4323 24.8244V24.4945L97.9188 24.7855C97.2979 24.902 97.0747 25.1445 97.0747 25.5423C97.0747 25.9886 97.3852 26.2311 97.9382 26.2311ZM103.581 27.0461C102.252 27.0461 101.427 26.008 101.427 24.349C101.427 22.6996 102.261 21.6518 103.581 21.6518C104.289 21.6518 104.881 21.9623 105.162 22.4959V20.0413H106.191V26.9297H105.23L105.201 26.1535C104.91 26.7162 104.299 27.0461 103.581 27.0461ZM103.852 26.1535C104.697 26.1535 105.162 25.4841 105.162 24.349C105.162 23.2041 104.697 22.5444 103.852 22.5444C103.028 22.5444 102.494 23.2235 102.494 24.349C102.494 25.455 103.028 26.1535 103.852 26.1535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.142 26.9297V22.0205H111.687V21.1764H112.279C113.065 21.1764 113.365 20.9047 113.365 20.0413H114.19V26.9297H113.142ZM115.658 26.9297V25.7072H116.909V26.9297H115.658ZM117.888 26.9297C117.888 25.3677 118.489 24.4072 120.469 23.3594C121.41 22.8645 121.769 22.5735 121.769 21.9332C121.769 21.2928 121.352 20.8465 120.527 20.8465C119.644 20.8465 119.139 21.3316 119.004 22.2145L117.917 22.1466C118.063 20.7592 118.994 19.886 120.527 19.886C121.992 19.886 122.855 20.7107 122.855 21.9138C122.855 22.9713 122.38 23.4758 120.993 24.2131C119.799 24.8535 119.198 25.5035 119.159 25.9692H122.855V26.9297H117.888ZM123.883 26.9297L125.755 24.2907L123.96 21.7682H125.105L126.376 23.6213L127.608 21.7682H128.782L127.007 24.3101L128.86 26.9297H127.715L126.386 24.9602L125.047 26.9297H123.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddn_2162_40698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.052 17.0225C176.419 17.0509 176.777 17.108 177.126 17.1914L177.062 17.4639C177.403 17.5456 177.734 17.6531 178.053 17.7852L178.16 17.5264C178.497 17.6662 178.821 17.8315 179.129 18.0205L178.982 18.2598C179.28 18.4425 179.562 18.6482 179.826 18.874L180.007 18.6611C180.283 18.8972 180.54 19.1545 180.776 19.4307L180.564 19.6123C180.79 19.8764 180.996 20.1586 181.179 20.4561L181.416 20.3086C181.605 20.6165 181.771 20.94 181.911 21.2773L181.652 21.3848C181.785 21.7037 181.893 22.0353 181.975 22.377L182.245 22.3115C182.329 22.6602 182.386 23.0188 182.414 23.3857L182.137 23.4072C182.15 23.5795 182.157 23.7539 182.157 23.9297C182.157 24.1055 182.15 24.2799 182.137 24.4521L182.414 24.4736C182.386 24.8406 182.329 25.1991 182.245 25.5479L181.975 25.4834C181.893 25.8248 181.784 26.1559 181.652 26.4746L181.911 26.582C181.771 26.9194 181.605 27.2428 181.416 27.5508L181.179 27.4043C180.996 27.7018 180.79 27.9839 180.564 28.248L180.776 28.4287C180.54 28.7049 180.283 28.9621 180.007 29.1982L179.826 28.9863C179.562 29.2121 179.28 29.4179 178.982 29.6006L179.129 29.8379C178.821 30.027 178.497 30.1931 178.16 30.333L178.053 30.0742C177.734 30.2064 177.403 30.3148 177.062 30.3965L177.126 30.667C176.777 30.7504 176.419 30.8074 176.052 30.8359L176.03 30.5586C175.858 30.572 175.684 30.5791 175.508 30.5791C175.332 30.5791 175.158 30.572 174.985 30.5586L174.964 30.8359C174.597 30.8074 174.238 30.7505 173.89 30.667L173.955 30.3965C173.613 30.3147 173.282 30.2065 172.963 30.0742L172.855 30.333C172.518 30.1931 172.195 30.0271 171.887 29.8379L172.034 29.6006C171.737 29.418 171.455 29.2121 171.19 28.9863L171.009 29.1982C170.733 28.9621 170.475 28.7049 170.239 28.4287L170.452 28.248C170.226 27.9838 170.021 27.7018 169.838 27.4043L169.599 27.5508C169.41 27.243 169.244 26.9192 169.104 26.582L169.363 26.4746C169.231 26.156 169.124 25.8247 169.042 25.4834L168.77 25.5479C168.686 25.1992 168.629 24.8405 168.601 24.4736L168.88 24.4521C168.873 24.366 168.868 24.2794 168.864 24.1924L168.859 23.9297C168.859 23.7539 168.867 23.5795 168.88 23.4072L168.601 23.3857C168.629 23.0188 168.686 22.6602 168.77 22.3115L169.042 22.377C169.124 22.0353 169.231 21.7036 169.363 21.3848L169.104 21.2773C169.244 20.9402 169.41 20.6164 169.599 20.3086L169.838 20.4561C170.021 20.1586 170.226 19.8765 170.452 19.6123L170.238 19.4297C170.474 19.1535 170.732 18.8962 171.008 18.6602L171.19 18.874C171.455 18.6482 171.737 18.4424 172.034 18.2598L171.887 18.0205C172.195 17.8315 172.518 17.6662 172.855 17.5264L172.963 17.7852C173.282 17.6529 173.613 17.5456 173.955 17.4639L173.89 17.1914C174.238 17.108 174.597 17.051 174.964 17.0225L174.985 17.3018C175.158 17.2884 175.332 17.2813 175.508 17.2812C175.684 17.2812 175.858 17.2884 176.03 17.3018L176.052 17.0225Z",
    stroke: "#005754",
    strokeWidth: 0.562272,
    strokeDasharray: "1.12 1.12",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iin_2162_40698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 175.509,
    cy: 23.9291,
    r: 6.36773,
    transform: "rotate(180 175.509 23.9291)",
    fill: "#E1FAFA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_in_2162_40698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.958 24.9799H172.277V23.1086H175.634V24.9799H178.747V22.875",
    stroke: "#005754",
    strokeWidth: 0.465463
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.827 26.9297V21.0018H186.712V20.0413H191.99V21.0018H189.875V26.9297H188.827ZM193.601 27.0461C192.524 27.0461 191.835 26.5319 191.835 25.6393C191.835 24.7564 192.349 24.281 193.485 24.0579L195.26 23.7183C195.26 22.9228 194.882 22.525 194.144 22.525C193.485 22.525 193.116 22.8257 192.98 23.3885L191.923 23.3205C192.117 22.2921 192.922 21.6518 194.144 21.6518C195.541 21.6518 196.288 22.4377 196.288 23.7765V25.7849C196.288 26.0371 196.366 26.1147 196.56 26.1147H196.744V26.9297C196.677 26.9491 196.521 26.9588 196.366 26.9588C195.774 26.9588 195.425 26.7356 195.347 26.1341C195.085 26.6774 194.406 27.0461 193.601 27.0461ZM193.766 26.2311C194.697 26.2311 195.26 25.649 195.26 24.8244V24.4945L193.747 24.7855C193.126 24.902 192.902 25.1445 192.902 25.5423C192.902 25.9886 193.213 26.2311 193.766 26.2311ZM197.546 21.0212V19.9928H198.613V21.0212H197.546ZM197.565 26.9297V21.7682H198.594V26.9297H197.565ZM201.097 26.9297C200.418 26.9297 199.972 26.5998 199.972 25.8334V20.0413H201V25.7363C201 25.9789 201.126 26.0856 201.359 26.0856H201.767V26.9297H201.097Z",
    fill: "#A2A2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.588 26.9297V22.0205H207.132V21.1764H207.724C208.51 21.1764 208.811 20.9047 208.811 20.0413H209.635V26.9297H208.588ZM211.103 26.9297V25.7072H212.354V26.9297H211.103ZM213.333 26.9297C213.333 25.3677 213.935 24.4072 215.914 23.3594C216.855 22.8645 217.214 22.5735 217.214 21.9332C217.214 21.2928 216.797 20.8465 215.972 20.8465C215.089 20.8465 214.585 21.3316 214.449 22.2145L213.362 22.1466C213.508 20.7592 214.439 19.886 215.972 19.886C217.437 19.886 218.301 20.7107 218.301 21.9138C218.301 22.9713 217.825 23.4758 216.438 24.2131C215.245 24.8535 214.643 25.5035 214.604 25.9692H218.301V26.9297H213.333ZM219.328 26.9297L221.2 24.2907L219.406 21.7682H220.55L221.821 23.6213L223.053 21.7682H224.227L222.452 24.3101L224.305 26.9297H223.16L221.831 24.9602L220.492 26.9297H219.328Z",
    fill: "#A2A2B8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.429 31.3048L240.179 29.7958M240.179 29.7958L237.553 28.0346C236.93 27.6172 236.764 26.7753 237.18 26.154C237.597 25.5327 238.439 25.3675 239.061 25.7849L243.155 28.5296M240.179 29.7958L239.67 30.5991C239.326 31.1408 239.307 31.7977 239.564 32.3397M243.155 28.5296L246.572 30.8216M243.155 28.5296L246.525 27.9733C248.713 27.7335 249.318 29.0363 249.593 29.8509L250.608 32.2848C251.541 34.2408 251.414 35.6947 250.815 36.5878L248.364 40.2437C247.225 41.9411 244.38 42.3272 242.744 41.2304L238.825 38.6545C238.063 38.1541 237.793 37.1662 238.194 36.3499L238.826 35.101M239.564 32.3397C239.699 32.6243 239.911 32.8773 240.191 33.0653L240.943 33.5696M239.564 32.3397L238.934 33.3676C238.41 34.1938 238.642 35.2879 239.456 35.8338L240.208 36.3381",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2162_40698",
    x: -1,
    y: 0,
    width: 296,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2162_40698",
    x: 46.9593,
    y: 9.65625,
    width: 200.277,
    height: 29.8001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.693,
    dy: 1.386
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0395
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddn_2162_40698",
    x: 64.8525,
    y: 16.9063,
    width: 14.3842,
    height: 14.3842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0374848,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0140568,
    dy: 0.168682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.112454
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0374848,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0140568,
    dy: 0.0562272
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0281136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2162_40698",
    result: "effect2_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_2162_40698",
    in2: "effect2_dropShadow_2162_40698",
    result: "effect3_noise_2162_40698"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_iin_2162_40698",
    x: 65.6895,
    y: 17.45,
    width: 12.7785,
    height: 13.0155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0421704,
    dy: 0.168682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.168682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.112454
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.168682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2162_40698",
    result: "effect2_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_2162_40698",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(33, 33, 41, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_in_2162_40698",
    x: 68.5918,
    y: 22.875,
    width: 6.93555,
    height: 2.36405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0281136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0611471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_2162_40698",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddn_2162_40698",
    x: 168.302,
    y: 16.9063,
    width: 14.3842,
    height: 14.3842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0374848,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0140568,
    dy: 0.168682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.112454
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0374848,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0140568,
    dy: 0.0562272
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0281136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2162_40698",
    result: "effect2_dropShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_2162_40698",
    in2: "effect2_dropShadow_2162_40698",
    result: "effect3_noise_2162_40698"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iin_2162_40698",
    x: 169.141,
    y: 17.45,
    width: 12.7785,
    height: 13.0155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0421704,
    dy: 0.168682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.168682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.112454
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.168682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2162_40698",
    result: "effect2_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_2162_40698",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(225, 250, 250, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_in_2162_40698",
    x: 172.045,
    y: 22.875,
    width: 6.93555,
    height: 2.36405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0281136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0611471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "71.13995361328125 71.13995361328125",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_2162_40698",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_2162_40698"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_2162_40698"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_40698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 48,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlay2);
export default __webpack_public_path__ + "static/media/howToPlay2.da11aca6a14ed43669fd84704364fd1b.svg";
export { ForwardRef as ReactComponent };